var make = require('./make_');
var arrMax = require('../array/max');
var objMax = require('../object/max');

    /**
     * Get maximum value inside collection
     */
    module.exports = make(arrMax, objMax);





//////////////////
// WEBPACK FOOTER
// ./~/mout/collection/max.js
// module id = 1575
// module chunks = 0 1 2